import { useState } from "react";
import { X, FileDown } from "lucide-react";

export default function BelgeTeminatModal({ rec, busy, onClose, onSubmit }) {
  const [f, setF] = useState({
    mahkeme: "BURSA 3. ASLİYE TİCARET MAHKEMESİ",
    dis_dosya_no: "",
    teminat_rakam: "",
    teminat_yazi: "",
  });
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const inp = "w-full px-3 py-2 border border-[#E7DECC] rounded-sm text-sm focus:outline-none focus:border-[#B8933F]";

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="teminat-modal">
      <div className="bg-white rounded-sm max-w-lg w-full">
        <div className="flex items-center justify-between px-5 py-3 border-b border-[#E7DECC]">
          <div className="kicker">TEMİNAT MEKTUBU — {rec.musteri}</div>
          <button onClick={onClose} data-testid="teminat-close" className="p-1 text-[#8C8377] hover:text-[#26231E]"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-xs text-[#8C8377]">Borçlu ad-soyad ve TC föyden otomatik gelir. Aşağıdaki alanları girin:</p>
          <div><label className="kicker block mb-1">MAHKEME</label><input value={f.mahkeme} onChange={(e) => set("mahkeme", e.target.value)} data-testid="teminat-mahkeme" className={inp} /></div>
          <div><label className="kicker block mb-1">D. İŞ DOSYA NO</label><input value={f.dis_dosya_no} onChange={(e) => set("dis_dosya_no", e.target.value)} data-testid="teminat-dis-dosya" placeholder="örn. 2026/107" className={inp} /></div>
          <div><label className="kicker block mb-1">TEMİNAT TUTARI (RAKAM)</label><input value={f.teminat_rakam} onChange={(e) => set("teminat_rakam", e.target.value)} data-testid="teminat-rakam" placeholder="boş = senet/asıl alacak tutarı" className={inp} /></div>
          <div><label className="kicker block mb-1">TEMİNAT TUTARI (YAZIYLA)</label><input value={f.teminat_yazi} onChange={(e) => set("teminat_yazi", e.target.value)} data-testid="teminat-yazi" placeholder="örn. İkiyüzotuzbin" className={inp} /></div>
        </div>
        <div className="flex justify-end gap-2 px-5 py-3 border-t border-[#E7DECC]">
          <button onClick={onClose} className="px-4 py-2 border border-[#E7DECC] rounded-sm text-sm">Vazgeç</button>
          <button onClick={() => onSubmit(f)} disabled={busy} data-testid="teminat-olustur" className="flex items-center gap-1.5 px-4 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium disabled:opacity-60">
            <FileDown className="w-4 h-4" /> {busy ? "Oluşturuluyor…" : "Oluştur & İndir"}
          </button>
        </div>
      </div>
    </div>
  );
}
